export const querykeys = {
  loggedUser: "logged-user",
  registerRequest: (token: string) => [`register-request`, token],
  hostedFieldToken: () => [`hosted-field-token`],
  plans: "plans",
  osm: "osm",
  serviceAvailability: "service-availability",
  lastPaymentMethod: "last-payment-method",
};
